// extracted by mini-css-extract-plugin
export default {"viewAllWrapper":"_8fd87116","viewAllCta":"_fab38df3"};